import * as moment from 'moment';

export class SaTargetProfile {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.lastUpdatedUtc) {
                this.lastUpdated = moment.utc(json.lastUpdatedUtc).format('YYYY-MM-DD');
                delete this['lastUpdatedUtc'];
            }
        }
    }

    id: number;
    index: number;
    name: string;
    turfRadCourseId: number;
    lastUpdated: string;
    stationCount: number;
    matchingStationsCount: number;
    isApplied: boolean;

    // Flag to tell API to update this profile with the current Target Values for the given TR OrgId and CourseId
    updateFromCurrent: boolean = false;

    // Flag to tell API to apply this Target Profile.
    applyProfile: boolean = false;
}

export class AppliedSaTargetProfile
{
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    turfRadCourseId: number;
    name: string;
}
